export default __webpack_public_path__ + "static/media/acceptRequestIcon.8281776e.svg";